import { useEffect, useState } from "react";
import api, { usd, formatApiErrorDetail } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Lock, Puzzle, Send, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export function ModuleUpgradeCard() {
  const [d, setD] = useState(null); const [busy, setBusy] = useState("");
  useEffect(() => { api.get("/my-modules").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  const locked = d.catalog.filter((m) => !m.core && m.key !== "hr" && !d.modules[m.key]);
  if (!locked.length) return null;
  const request = async (m) => {
    const note = window.prompt(`Request ${m.label}? Add a note for your RightPay team (optional):`, "");
    if (note === null) return;
    setBusy(m.key);
    try { const { data } = await api.post("/my-modules/request", { module: m.key, note }); toast.success(data.message); setD({ ...d, requested: [...d.requested, m.key] }); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); } finally { setBusy(""); }
  };
  return (
    <Card className="p-5 space-y-3" data-testid="module-upgrade-card">
      <div><h2 className="font-display font-semibold text-base flex items-center gap-2"><Puzzle className="w-5 h-5 text-primary" /> Available add-on modules</h2><p className="text-xs text-muted-foreground mt-0.5">Your plan includes the Payroll core module (paystubs, direct deposit, check printing, year-end). Add more capabilities any time — your RightPay team enables them for you.</p></div>
      <ul className="grid sm:grid-cols-2 gap-3">{locked.map((m) => { const req = d.requested.includes(m.key); return (
        <li key={m.key} className="rounded-lg border p-4 flex flex-col gap-2" data-testid={`locked-module-${m.key}`}>
          <div className="flex items-start justify-between gap-2"><div className="font-medium text-sm flex items-center gap-1.5"><Lock className="w-3.5 h-3.5 text-muted-foreground" /> {m.label}</div>{m.fee > 0 && <Badge variant="outline" className="text-primary border-primary/30">{usd(m.fee)}/mo</Badge>}</div>
          <p className="text-xs text-muted-foreground flex-1">{m.desc}</p>
          {req ? <Badge variant="outline" className="self-start text-emerald-700 border-emerald-300" data-testid={`module-requested-${m.key}`}><CheckCircle2 className="w-3 h-3 mr-1" /> Requested — we'll be in touch</Badge>
            : <Button size="sm" className="self-start" data-testid={`request-module-${m.key}`} disabled={busy === m.key} onClick={() => request(m)}><Send className="w-3.5 h-3.5 mr-1.5" /> Request this module</Button>}
        </li>); })}</ul>
    </Card>
  );
}
